<template>
  <div></div>
</template>

<script lang="ts" src="./dl-href-interceptor.ts"></script>
